import { useState } from 'react';

interface DesignCompareProps {
  beforeUrl?: string;
  beforeLabel?: string;
  afterUrl?: string;
  afterLabel?: string;
  compact?: boolean;
}

export function DesignCompare({ beforeUrl, beforeLabel = 'Before', afterUrl, afterLabel = 'After', compact = false }: DesignCompareProps) {
  const [fullscreenUrl, setFullscreenUrl] = useState<string | null>(null);

  if (!beforeUrl && !afterUrl) return null;

  const single = !beforeUrl || !afterUrl;
  const maxH = compact ? 200 : 350;

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: single ? '1fr' : '1fr 1fr', gap: 12, marginBottom: 12 }}>
        {beforeUrl && (
          <ImageCard url={beforeUrl} label={beforeLabel} maxH={maxH} onClick={() => setFullscreenUrl(beforeUrl)} />
        )}
        {afterUrl && (
          <ImageCard url={afterUrl} label={afterLabel} maxH={maxH} onClick={() => setFullscreenUrl(afterUrl)} />
        )}
      </div>

      {/* Fullscreen overlay */}
      {fullscreenUrl && (
        <div
          onClick={() => setFullscreenUrl(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.85)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'zoom-out', padding: 40,
          }}
        >
          <img
            src={fullscreenUrl}
            alt="Full view"
            style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8 }}
          />
          <div style={{ position: 'absolute', top: 20, right: 28, color: 'white', fontSize: 28, fontWeight: 300, cursor: 'pointer' }}>
            &times;
          </div>
        </div>
      )}
    </>
  );
}

function ImageCard({ url, label, maxH, onClick }: { url: string; label: string; maxH: number; onClick: () => void }) {
  return (
    <div>
      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4 }}>{label}</div>
      <div
        onClick={onClick}
        style={{
          borderRadius: 6, border: '1px solid var(--color-border)', background: 'var(--bg-secondary)',
          overflow: 'hidden', cursor: 'zoom-in', height: maxH,
        }}
      >
        <img
          src={url}
          alt={label}
          style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'top center' }}
        />
      </div>
    </div>
  );
}
